import React from 'react';

const MINIMAP_STYLE = {
	position: 'absolute',
	bottom: 10,
	right: 10,
	width: 200,
	height: 150,
	zIndex: 5,
	background: '#fff',
	border: '1px solid #d9d9d9',
	borderRadius: 4,
	boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
};

/**
 * Контейнер для плагина X6 MiniMap.
 * Сам плагин монтирует содержимое внутрь этого div по ref.
 */
const ArchiX6Minimap = React.forwardRef(function ArchiX6Minimap(_, ref) {
	return <div ref={ref} style={MINIMAP_STYLE} />;
});

export default ArchiX6Minimap;
